import React from 'react'

export default function Login() {
    return (
        <div className='container' style={{padding : "50px"}}>
            
        </div>
    )
}
